import React, {useEffect} from 'react';
import {useLocation} from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';
import {CustomDelete, FullTable} from 'components';
import {goalsNotYet, ACTION_TYPE, goalsHead, goalsBody, ACTION_TYPE_DELETE_LIBRARY_GOAL} from './constants';
import {tagEnums, useModal, useSecondaryModal, PermissionList, RolePermission} from 'utils';
import {AddGoal} from './addGoal';
import {libraryActions, tagActions} from 'store';
import {LibraryGoalDetails} from './goalDetails';

export const GoalsTab = () => {
    const {goalList, domainList} = useSelector((state) => ({
        goalList: state.library.goalList,
        domainList: state.domains.domainList,
    }));
    const dispatch = useDispatch();
    const location = useLocation();
    const info = location?.state;
    const {open} = useModal();
    const {openSecondary} = useSecondaryModal();
    const hasPermission = RolePermission([PermissionList.GOAL_CREATE?.code]);

    const renderParams = () => {
        const pushInfo = {
            ...info,
        };
        pushInfo.skip = info?.skip ? info?.skip : 0;
        pushInfo.limit = 50;

        delete pushInfo.page;
        delete pushInfo.activeTab;
        return pushInfo;
    };

    useEffect(() => {
        dispatch(tagActions.getTags({module: tagEnums.LIBRARY_GOAL}));
    }, [dispatch]);

    useEffect(() => {
        getGoals();
    }, [info]);

    const getGoals = (load) => {
        dispatch(libraryActions.getLibraryGoals(renderParams(), load));
    };

    const handleClickButton = (item, name) => {
        if (!hasPermission) return;
        if (name === 'edit') {
            open(<AddGoal requestParams={renderParams()} info={item} afterSuccess={(item) => goalDetails(item?.id)}/>);
        }

        if (name === 'clone') {
            open(<AddGoal isClone info={item} requestParams={renderParams()}
                          afterSuccess={(item) => goalDetails(item?.id)}/>);
        }

        if (name === 'delete') {
            open(
                <CustomDelete
                    text="Are you sure you want to delete this Goal? This action cannot be undone."
                    info="Delete Goal"
                    handleDel={() => dispatch(libraryActions.deleteLibraryGoal(item?.id, renderParams()))}
                    actionType={ACTION_TYPE_DELETE_LIBRARY_GOAL}
                    innerText={'Delete'}
                />
            );
        }
    };

    const goalDetails = (goalId) => {
        openSecondary(
            <LibraryGoalDetails
                goalId={goalId}
                requestParams={renderParams()}
                afterSuccess={() => getGoals('noLoad')}
            />
        );
    };

    return (
        <div>
            <FullTable
                head={goalsHead(domainList, hasPermission)}
                body={goalsBody(renderParams(), hasPermission)}
                loadingType={ACTION_TYPE}
                // Server order: the column the user picked, else the org's default goal order.
                list={goalList?.data?.length ? goalList.data : []}
                listCount={goalList?.count}
                handleClickButton={handleClickButton}
                handleClick={(goalId) => goalDetails(goalId)}
                notYet={goalsNotYet}
                margin={'0'}
                handleAddNoYet={
                    hasPermission
                        ? () => open(<AddGoal requestParams={renderParams()}
                                              afterSuccess={(item) => goalDetails(item?.id)}/>)
                        : undefined
                }
            />
        </div>
    );
};
